
<div class="description" *ngIf="!addNewCreditCard">
    <b>Cartões cadastrados</b>
    <p class="subtitle">Você pode cadastrar até 5 cartões.</p>
</div>

<div id="errorMessage" class="second-card-suggestion-container" *ngIf = "isACreditCardError && (this.paymentData.card.cardNumber  ) && !this.formOpened" >
    <div class="second-card-suggestion-error" >
        <div class="left-card-info">
            <div class="payment-icon pme-payment-icon-{{getBrandCSSMatching(this.paymentData.card.brand)}}"></div>
            <div class="informations">
                <span class="mat-small" style="white-space: nowrap; ">{{getLastCreditCardvalues(this.paymentData.card.cardNumber)}}</span>
            </div>
        </div>
        <div class="error-message" >
            <img src="/assets/images/new-dialog-icons/error-credit-card-suggestion.svg" alt="error" style="width: 20px; height: 20px; ">
            <p>{{adyenCardError}}</p>
        </div>
    </div>
    <div class="second-card-suggestion-message" *ngIf = "this.validCards  && this.validCards.length >= 1 && displaySuggestionMessageFlag">

        <div class="suggestion-title">
            <img src="/assets/images/new-dialog-icons/suggestion-message-card-icon.svg" alt="card" style="width: 24px; height: 24px; ">
            <p>{{this.suggestionMessage.title}}</p>
        </div>
        <div class="suggestion-message-text"
            [innerHTML]="this.suggestionMessage.subtitle">
        </div>
        

    </div>
</div>



<!-- LEMBBRA DO DISABLEEEEEE AAAAAAAA -->
<div>
    <div *ngIf="!addNewCreditCard">
        <div class="info-message-text" *ngIf="creditCardsData.length >= 5">
            <pme-alert type="info" title="Atenção!">
                <strong>Limite de 5 cartões atingido.</strong> Para adicionar um novo, exclua um existente.
              </pme-alert>
            
        </div>

        


        <ng-container  *ngFor="let card of creditCardsData">
            <mat-card  class="credit-card-unit "
                [class.uniqueCard]="this.validCards && this.validCards.length === 1 && !displaySuggestionMessageFlag"
                [class.selected]="selectedRadioButton === card.accountPaymentDataId && card.situation !== 'expired'"
                [class.expiredCard]="card.situation === 'expired'"
                [ngClass]="{'button':card.situation !== 'expired'}" 
                (click)="onRadioButtonChange(card.accountPaymentDataId)">
                <div class="card-design">
                    <div class="left-content" [ngClass]="{'grayed-out': card.situation === 'expired'}">
                        <mat-radio-button class="custom-radio"
                        [class.expiredRadio]="selectedRadioButton === card.situation === 'expired'"
                            [checked]="selectedRadioButton === card.accountPaymentDataId && card.situation !== 'expired'"
                            [disabled]="card.situation === 'expired'"
                            (change)="onRadioButtonChange(card.accountPaymentDataId)"></mat-radio-button>

                        <div class="payment-icon pme-payment-icon-{{getBrandCSSMatching(card.brand)}}"></div>

                        <div class="informations">
                            <b>{{ card.nickname }}</b>
                            <span class="mat-small">{{getLastCreditCardvalues(card.number)}}</span>
                        </div>
                    </div>
                    <div class="delete-icon" style="margin-left: auto;">
                        <span class="display-utils-hide-lt-md">
                            <div class="expiring" *ngIf="card.situation === 'expiring'">
                                <mat-icon class="expiring-icon">calendar_month</mat-icon>
                                <p>Cartão próximo<br>ao vencimento</p>
                            </div>

                            <div class="expiring" *ngIf="card.situation === 'expired'">
                                <mat-icon class="expired-icon">close</mat-icon>
                                <p>Cartão vencido</p>
                            </div>
                        </span>
                        <button mat-stroked-button type="button" class="transparent-button button trash"
                        [class.selectedTrash]="selectedRadioButton === card.accountPaymentDataId && card.situation !== 'expired'"
                            (click)="onDeleteClick(card.accountPaymentDataId)">
                            <img src="/assets/images/delete-credit-card.png" alt="Delete" style="width: 20px; height: 20px; ">
                        </button>
                    </div>
                </div>
                <div *ngIf="selectedRadioButton !== null && selectedRadioButton === card.accountPaymentDataId "
                    style="padding-top: 15px">
                    <div class="adyenMaterial">
                        <div class="inputTitle" *ngIf="selectedPaymentCondition">
                            <label>Número de parcelas</label>
                        </div>
                        <div class="select">
                            <select class="paymentOptions" required [(ngModel)]="this.selectedPaymentCondition" (change)="handleIstallments()">
                                <option [ngValue]="null" disabled>
                                  Número de parcelas
                                </option>

                                <option *ngFor="let option of availablePaymentOptions;" [ngValue]="option.identifier" selected>
                                    {{option.installments}}X de {{option.installmentValue | currency: 'R$'}}
                                </option>
                            </select>
                            <div class="invalid-container" *ngIf="card.situation==='expired'">
                                <img src="/assets/images/info_icon.png" alt="Delete" style="width: 20px; height: 20px; ">
                                <p>Cartão inválido</p>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="display-utils-only-lt-md">
                    <div class="expiring" *ngIf="card.situation === 'expiring'">
                        <mat-icon class="expiring-icon">calendar_month</mat-icon>
                        <p>Cartão próximo ao vencimento</p>
                    </div>
                    <div class="expiring" *ngIf="card.situation === 'expired'">
                        <mat-icon class="expired-icon">close</mat-icon>
                        <p>Cartão vencido</p>
                    </div>
                </div>
                <!-- cartão padrão -->
                <div *ngIf="selectedRadioButton === card.accountPaymentDataId && !card.isDefaultCard && card.situation !== 'expired'" class="slider-toggle">
                    <mat-slide-toggle [(ngModel)]="this.defaultCard" class="toggle" (click)="this.toggleDefaultCard(this.defaultCard)">
                        <span style="white-space: normal;">Definir cartão como padrão para próximas compras</span>
                    </mat-slide-toggle>
                </div>
            </mat-card>
        </ng-container>
    </div>

    <mat-card *ngIf="!maxLimitCreditCards && !addNewCreditCard" class="button add-new-card" (click)="this.onAddNewCreditCard()">
        <div class="card-design addNewCard-container">
            <div class="left-content">
                <button mat-stroked-button type="button" class="transparent-button" (click)="this.onAddNewCreditCard() " style="width: auto !important;">
                    <img src="/assets/images/fi_plus.png" alt="AddNewCard" style="width: 20px; height: 20px; ">
                </button>
                <p class="addNewCard" (click)="this.onAddNewCreditCard()">Adicionar cartão de crédito</p>
            </div>
        </div>
    </mat-card>
</div>
